import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { ReadMore } from '../ReadMore';

interface IDescriptionProps {
  description: string;
  isNeedReadMore: boolean;
  isExpanded: boolean;
  onClick: () => void;
  maxHeight?: number | string;
  descriptionRef?: React.Ref<HTMLDivElement>;
}

export const Description: React.FC<IDescriptionProps> = ({
  description,
  isNeedReadMore,
  isExpanded,
  onClick,
  maxHeight,
  descriptionRef,
}) => {
  return (
    <div className={styles['container']}>
      <div data-testid="description" className={styles['description']} style={{ maxHeight }}>
        <ArticleParagraph1 ref={descriptionRef}>{description}</ArticleParagraph1>
      </div>
      {isNeedReadMore && <ReadMore isExpanded={isExpanded} onClick={onClick} />}
    </div>
  );
};
